import { Component, ReactNode } from 'react';
import { withTranslation } from 'react-i18next';

import { TFunction } from 'i18next';
import * as _ from 'lodash-es';

import { ErrorLayout } from '../components';
import { PAGE_PATH } from '../constants';

type InitErrorBoundaryState = {
  hasError: boolean;
  error?: Error;
};

type InitErrorBoundaryProps = {
  children: ReactNode;
  t: TFunction;
};

// NOTE: ErrorBoundaryはclass componentでしか行えないため、例外的にclass componentで実装しています
export class BaseInitErrorBoundary extends Component<
  InitErrorBoundaryProps,
  InitErrorBoundaryState
> {
  constructor(props: InitErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): InitErrorBoundaryState {
    window.hideSplash();
    return { hasError: true, error };
  }

  render() {
    const { hasError, error } = this.state;
    const { children, t } = this.props;

    const traceparentId = _.get(error, 'config.headers.Traceparent', undefined);

    const bottomLink = {
      text: t('LOGOUT'),
      onClick: () => {
        window.location.replace(PAGE_PATH.LOGOUT);
      },
    };

    if (hasError) {
      return (
        <>
          <div>InitErrorBoundary</div>
          <ErrorLayout
            title={t('ERROR_MESSAGE.001')}
            message={t('ERROR_MESSAGE.002')}
            bottomLink={bottomLink}
            traceparentId={traceparentId}
          />
        </>
      );
    }

    return children;
  }
}

export const InitErrorBoundary = withTranslation()(BaseInitErrorBoundary);
